<template>
  <!-- 重要讲话和重要活动 -->
  <div class="leader" id="zyjh">
    <!-- 首页的 -->
    <div class="sy-zyjh u-clearfix" v-if="$route.name==='index' || $route.name==='index1'">
      <div class="pic fl">
        <img :src="zyjhzyhdImg" alt="">
      </div>

      <div class="zyjh-content u-r">
				<el-radio v-model="radio" label="1" border :class="{'zyhd_btn':true,'zyjh_btn':radio==='1'}" @change="getSpeackFullTextListData">重要讲话</el-radio>
				<el-radio v-model="radio" label="2" border :class="{'zyhd_btn':true,'zyjh_btn':radio==='2'}" @change="getSpeackFullTextListData">重要活动</el-radio>
        
				<ol class="zyjh-cont" v-loading="loading">
					<li v-for="(item, index) in speackFullTextListData" :key="index">
						<a class="text-ellipsis"
							:href="item.nodeUrl"
							target="_blank"
							:title="item.title"
							>{{ item.title }}</a
						>
						<span class="zyjh-time">{{ item.pubDate }}</span>
					</li>
				</ol>
      </div>
    </div>

		<template v-else>
    <!-- 讲话全文 -->
    <div class="leader-t clearfix fl">
      <div class="leader-t-con clearfix">
        <h2 class="title title1">重要讲话</h2>
        <div class="pic fl">
          <div class="noData" v-if="speackFullTextLoading">
            <p>当前没有匹配的图片</p>
          </div>
          <el-carousel
            height="300px"
            trigger="click"
            indicator-position="outside"
            v-if="speackFullTextData && speackFullTextData.length > 0"
          >
            <el-carousel-item
              v-for="(item, index) in speackFullTextData"
              :key="index"
            >
              <div class="img-wrap">
                <a
                  class="small"
                  :href="item.url"
                  :title="item.title"
                  target="_blank"
                >
                  <span class="text-ellipsis spanID">{{ item.title }}</span>
                </a>
                <img
                  :src="downloadUrl + item.file_path"
                  alt=""
                  width="447"
                  height="300"
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="con fr">
          <p class="con-title">{{ speackFullTextListTitle }}</p>
          <p class="abstract">摘要：{{ speackFullTextListAbstract }}</p>
          <ol class="gx_l_data clearfix">
            <li v-for="(item, index) in speackFullTextListData" :key="index">
              <a
                :href="
                  urlPath +
                    'KCMS/detail/detail.aspx?dbcode=' +
                    item.table_name.substring(0, 4) +
                    '&dbname=' +
                    item.table_name +
                    '&filename=' +
                    item.file_name +
                    '&'
                "
                target="_blank"
                :title="item.title"
                >{{ item.title }}</a
              >
              <span>{{ item.pub_date }}</span>
            </li>
            <li class="more">
              <a
                :href="
                  urlPath +
                    'KNS/brief/result.aspx?dbprefix=XJZTZK&NaviField=%E8%A1%8C%E4%B8%9A%E5%88%86%E7%B1%BB%E4%BB%A3%E7%A0%81&systemno=bq315&DSCode=bq316'
                "
                target="_blank"
                >更多&gt;&gt;</a
              >
            </li>
          </ol>
        </div>
      </div>
    </div>
    <!-- 重要活动 -->
    <div class="leader-b clearfix fr">
      <h2>重要活动</h2>
      <ol class="gx_l_data clearfix" v-loading="loadingImportantActivities">
        <li v-for="(item, index) in importantActivitiesData" :key="index">
          <a
            :href="
              urlPath +
                'KCMS/detail/detail.aspx?dbcode=' +
                item.table_name.substring(0, 4) +
                '&dbname=' +
                item.table_name +
                '&filename=' +
                item.file_name +
                '&'
            "
            target="_blank"
            :title="item.title"
            >{{ item.title }}</a
          >
          <span>{{ item.pub_date }}</span>
        </li>
        <li class="more">
          <a
            :href="
              urlPath +
                'KNS/brief/result.aspx?dbprefix=XJZTZK&NaviField=%E8%A1%8C%E4%B8%9A%E5%88%86%E7%B1%BB%E4%BB%A3%E7%A0%81&systemno=bq315&DSCode=bq317'
            "
            target="_blank"
            >更多&gt;&gt;</a
          >
        </li>
      </ol>
    </div>
	</template>
  </div>
</template>
<script>
export default {
  name: "ZYJHZYHD",
  props: [
    "downloadUrl",
    "urlPath",
  ],
  data() {
    return {
      radio: "1",
			loading:false,
			//左侧-轮播图
			speackFullTextData:[],//讲话全文态数据-图片
			speackFullTextLoading:false,//图片无数据占位符
			//讲话全文
			speackFullTextDataNum:"",//数量
			//右侧-数据
			speackFullTextListTitle:"",//标题
			speackFullTextListAbstract:"",//摘要

			speackFullTextListData:[],//讲话全文list数据右侧

			//重要活动
			importantActivitiesData:[],//重要活动数据
			loadingImportantActivities:false,//加载中
      list:[],
      uidList:[],
      zyjhzyhdImg:''
    };
  },
  created() {
    this.getList()
		this.getZyjhzyhdImg();
	},
  methods: {
    getList(){
      this.axios.get("data/custom/classType?uid=b2d0681b-f3be-49d6-ba3b-6ac137be9e63&pageNum=1&pageSize=10").then((res) => {
        if (res.status == 200) {
          this.list = res.data.rows;
          this.uidList = this.list.map(item => item.uid)
          this.getSpeackFullTextListData()
        } else {
          this.$message.error("获取失败！");
        }
      });
    },
		//讲话全文====
		//左侧轮播图
		getZyjhzyhdImg(){
      this.axios
        .post("data/custom/buildlist", {
          uid: "fc28ebf0-43cf-4a0f-a86b-fde9e9a141a0",
          pageNum: 1,
          pageSize: 10,
        })
        .then((res) => {
          if (res.status == 200) {
            this.zyjhzyhdImg = res.data.rows[0].imageHttpUrl;
          } else {
            this.$message.error("获取失败！");
          }
        });
		},
		//右侧数据
		//讲话全文list数据右侧
		getSpeackFullTextListData(){
      this.loading = true
			this.axios
				.post(`data/cnki/getKbaseList`,{
        uid: this.uidList[Number(this.radio)],
        pageNum: 1,
        pageSize: 10
      }).then((res) => {
          this.loading = false
					if (res.status == 200) {
						this.speackFullTextListData = res.data.rows.filter((item,i) => i<5);	
					} else {
						this.$message.error("获取讲话全文list数据右侧失败！");
					}
				});
		},
	},
};
</script>
<style lang="scss" scoped>
.title {
  height: 63px;
  line-height: 63px;
  font-size: 28px;
  color: #ac0101;
  text-align: center;
}
.title1 {
  background: url("../../assets/images/title1.png") center bottom no-repeat;
  height: 58px;
  line-height: 50px;
  margin-bottom: 42px;
  text-align: center;
}
.pic {
  width: 440px;
  height: 100%;
  .el-carousel__item {
    .img-wrap {
      position: relative;
			height: 100%;
      .small {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        line-height: 40px;
        font-size: 14px;
        font-weight: normal;
        span {
          padding: 0 10px;
          max-width: 95%;
          display: inline-block;
        }
        .spanID {
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  .el-carousel__indicators--outside button {
    background: #cc1e1e;
  }
  .el-carousel__button {
    height: 4px;
  }
  .el-carousel__arrow {
    font-size: 16px;
    background-color: rgba(31, 45, 61, 0.3);
    &:hover {
      background-color: rgba(31, 45, 61, 0.6);
    }
  }
  .noData {
    height: 100%;
    background: url("../../assets/images/noData.jpg") center 40px no-repeat;
    border: 1px solid #d2deed;
    text-align: center;
    p {
      font-size: 18px;
      color: #aab3d2;
      padding-top: 230px;
    }
  }
}
</style>
